import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
const FOR_YOU = ['Compraste tu primer iPhone y quieres aprender a usarlo bien desde el principio.', 'Cambiaste de Android a iPhone y todavía te sientes perdido con iOS.', 'Tienes iPhone hace meses o años, pero sientes que solo usas lo básico.', 'Quieres aprender trucos, funciones ocultas y configuraciones útiles.', 'Quieres mejorar tu batería, organizar tus apps y proteger tus datos.', 'Quieres tomar mejores fotos y videos sin comprar equipo extra.', 'Buscas una guía clara, ordenada y fácil de aplicar paso a paso.', 'Quieres sentir que por fin estás aprovechando todo lo que pagaste por tu iPhone.'];
const NOT_FOR_YOU = ['Ya dominas todas las funciones avanzadas de iOS y te consideras un experto.', 'No tienes ningún interés en aprender nuevas funciones de tu celular.', 'Buscas explicaciones técnicas complejas o contenido de desarrollo de apps.', 'No estás dispuesto a dedicar unos minutos para aplicar pasos simples.'];
export function Audience() {
  return <Section className="bg-ink-950" data-id="element-28" data-mp="16fb44pee9ot3">
      <SectionTitle eyebrow="Para quién es" data-id="element-29" data-mp="1bb9nfykv8gmn">
        ¿Este producto es para ti?
      </SectionTitle>

      <div className="grid gap-5 md:grid-cols-2" data-id="element-30" data-mp="1gaw82t30wz5h">
        <div className="rounded-3xl border border-emerald-400/20 bg-emerald-400/[0.04] p-6 sm:p-8" data-id="element-31" data-mp="1gdihyzddzqqv">
          <h3 className="mb-5 text-lg font-bold text-emerald-300" data-id="element-32" data-mp="1kaek0zcv9zw6">
            Sí, es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-33" data-mp="1uaxawe2umgnl">
            {FOR_YOU.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-white/70" data-id="element-34" data-mp="1u9chirs9t3rb">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-35" data-mp="1z2ymdxs703ck" />
                <span data-id="element-36" data-mp="24073dv1lu1c8">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl border border-white/8 bg-ink-900 p-6 sm:p-8" data-id="element-37" data-mp="283d82y92jkgl">
          <h3 className="mb-5 text-lg font-bold text-white/70" data-id="element-38" data-mp="2d0viyu6nc9r8">
            Siendo honestos, no es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-39" data-mp="czyqn49wkkuy">
            {NOT_FOR_YOU.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-white/55" data-id="element-40" data-mp="8xtunyvzfc55">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400/70" aria-hidden="true" data-id="element-41" data-mp="mooygwrmj31v" />
                <span data-id="element-42" data-mp="hy8hx3sib1ba">{item}</span>
              </li>)}
          </ul>
          <p className="mt-6 border-t border-white/8 pt-5 text-sm font-semibold text-white" data-id="element-43" data-mp="hwxifg63gfpz">
            Si no eres ninguna de esas personas, este producto fue hecho
            exactamente para ti.
          </p>
        </div>
      </div>
    </Section>;
}